import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { LazyImage } from '@/components/common/admin/mobile/LazyImage';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { SVG_COMPONENTS as ADMIN_SVG_COMPONENTS } from '@/assets/admin';
import { useResidentChatWindowStyles } from '@/components/residents/propertyChat/ResidentChatWindow.styles';
import { useThemeColors } from '@/hooks/residents/useThemeColors';
import type { UploadFile } from '@/components/common/admin/mobile/FileUploadSection';
import { getFileExtension, truncateFileName } from '@/utils/common/file';

export const FileUploadBubble: React.FC<{ file: UploadFile; onDelete: () => void }> = ({ file, onDelete }) => {
  const styles = useResidentChatWindowStyles();
  const { semantic, colors } = useThemeColors();
  const isImage = file.type?.startsWith('image/');

  if (isImage && file.uri) {
    return (
      <View style={styles.imageUploadBubble}>
        <LazyImage
          source={{ uri: file.uri }}
          style={styles.imageUploadPreview}
          resizeMode="cover"
          placeholder={(
            <View style={styles.imageUploadPlaceholder}>
              <RESIDENTS_SVG_COMPONENTS.DOCUMENT width={16} height={16} color={semantic.interactive.primaryHover} />
            </View>
          )}
        />
        <TouchableOpacity style={styles.deleteImageButton} onPress={onDelete}>
          <ADMIN_SVG_COMPONENTS.X_CIRCLE width={16} height={16} color={semantic.text.inverse} />
        </TouchableOpacity>
      </View>
    );
  }

  return (
    <View style={styles.fileUploadBubble}>
      <RESIDENTS_SVG_COMPONENTS.DOCUMENT width={32} height={32} color={semantic.interactive.primaryHover} />
      <View style={styles.fileUploadInfo}>
        <Text style={styles.fileUploadName}>{truncateFileName(file.name || 'File', 20)}</Text>
        <Text style={styles.fileUploadExtension}>{getFileExtension(file.name || '')}</Text>
      </View>
      <TouchableOpacity onPress={onDelete}>
        <ADMIN_SVG_COMPONENTS.X_CIRCLE width={16} height={16} color={colors.text.primary} />
      </TouchableOpacity>
    </View>
  );
};

export default FileUploadBubble;
